//# sourceMappingURL=custom-page-size.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/custom-page-size.interface.js
// module id = 1166
// module chunks = 4